import { List } from 'immutable';
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseEntity, BaseInlineContainer, DefaultButtonsConfig, InlineContainerService, UserService} from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

//import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'yt-eprijemnica-prevoz-update-container',
  templateUrl: './eprijemnica-prevoz-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class EPrijemnicaPrevozUpdateContainer<T extends BaseEntity> 
extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
              activatedRoute: ActivatedRoute,
              userService: UserService,
              ){
super(inlineContainerService, activatedRoute, userService);
}
  @ViewChild("baseDetailList", { static: false }) baseDetailList: any;

 tempItems: List<T>
 
  ngAfterViewInit() {


    if (this.baseDetailList.tableConfig) {

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig = false;
      this.baseDetailList.tableConfig.DeleteIcon.Visible = false;
    }
  }
  // setItems(items) {
  //    this.tempItems = items;
  //   }


  }


